/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { getTarjetas, saveTarjetaBanco } from "../../services/TarjetaBancoService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  idTarjeta: null,
  bancoEntidad: "",
  descripcionOdoo: "",
  observaciones: "",
};

const nameItemText = "Tarjeta Banco-Entidad";
const itemGender = "F";
//
// ########################################################################### 
//
const TarjetaBancoDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [valueACTarjetas, setValueACTarjetas] = useState({})
  const [inputValueACTarjetas, setInputValueACTarjetas] = useState("");
  const [tarjetas, setTarjetas] = useState([]);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadTarjetas();

    if (actionCrud === "new") {
      setValueACTarjetas(tarjetas[0]);
      setItemCrudLocal(initialState);
    } else {
      setValueACTarjetas(itemCrud.tarjeta);
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {

    if (actionCrud === "new" || actionCrud === "update") {
      if (!valueACTarjetas) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar una tarjeta",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.bancoEntidad === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el nombre de la entidad de la tarjeta",
        });
        setShowMessage(true);
        return;
      }

      if (!itemCrudLocal.descripcionOdoo || itemCrudLocal.descripcionOdoo.length > 5) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el código Odoo de no más de 5 caracteres",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      id_tarjeta: valueACTarjetas.id || null,
      banco_entidad: itemCrudLocal.bancoEntidad,
      descripcion_odoo: itemCrudLocal.descripcionOdoo,
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveTarjetaBanco(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const loadTarjetas = async () => {

    setIsDoingSomething(true);
    const response = await getTarjetas();
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      let _tarjetas = [];
      _response.forEach((item) => {
        _tarjetas.push({
          id: item.id,
          label: (item.marca).toUpperCase() + " - " + (item.tipo).toUpperCase(),
        });
      });
      setTarjetas(_tarjetas);
    } else {
      setTarjetas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>

            <Grid item xs={12}>
              <Autocomplete
                id="idTarjeta"
                sx={{ width: "100%" }}
                size="small"
                value={valueACTarjetas ?? null}
                onChange={(event, newValue) => {
                  setValueACTarjetas(newValue);
                }}
                inputValue={inputValueACTarjetas}
                onInputChange={(event, newInputValue) => {
                  setInputValueACTarjetas(newInputValue);
                }}
                options={tarjetas}
                renderInput={(params) => <TextField {...params} label="Tarjeta" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                getOptionLabel={(option) => option.label || ""}
                disableClearable={true}
              />

            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="bancoEntidad"
                label="Banco Entidad"
                variant="outlined"
                size="small"
                name="bancoEntidad"
                value={itemCrudLocal.bancoEntidad}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 5
                }}
                id="descripcionOdoo"
                label="Código Odoo"
                variant="outlined"
                size="small"
                name="descripcionOdoo"
                value={itemCrudLocal.descripcionOdoo}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default TarjetaBancoDialog;